import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

const COMMUNITY_ROLES_RESOURCE = 'communityRoles';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: COMMUNITY_ROLES_RESOURCE,
      method: 'get',
      request: (communityId, t) => ({
        url: apiRoutes.communityRoles2(communityId),
        meta: {
          toaster: {
            onErrorMessage: createErrorMessage(t, 'getCommunityRolesFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);
